// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"936829d0","239":"186e9833","455":"f30e29b8"}[chunkId] + ".chunk.js";
};